import { TOKENS, LOGIN_USER_INFO_KEY, LOGIN_USER_INVITE_CODE_KEY, LOCAL_INFO } from 'utils/constants'
import { SessionStorage, LOTTERY_WEB_SITE } from 'utils/config'
import auth from 'request/auth'

export default () => {
  const SET_TOKENS = 'SET_TOKENS'
  const DEL_TOKENS = 'DEL_TOKENS'
  const SET_LOGIN_USER_INFO = 'SET_LOGIN_USER_INFO'
  const SET_INVITE_CODE = 'SET_INVITE_CODE'
  const JUMP_TO_SITE = 'JUMP_TO_SITE'
  const SET_LOCAL_INFO = 'SET_LOCAL_INFO'

  const state = {
    tokens: SessionStorage.get(TOKENS) || {},
    loginUserInfo: SessionStorage.get(LOGIN_USER_INFO_KEY) || {},
    inviteCode: SessionStorage.get(LOGIN_USER_INVITE_CODE_KEY) || {},
    localInfo: SessionStorage.get(LOCAL_INFO) || {}
  }

  const getters = {
    tokens: state => state.tokens,
    loginUserInfo: state => state.loginUserInfo,
    inviteCode: state => state.inviteCode,
    localInfo: state => state.localInfo
  }

  const actions = {
    setTokens ({ commit }, value) {
      commit(SET_TOKENS, value)
    },
    delTokens ({ commit }) {
      commit(DEL_TOKENS)
    },
    setLoginUserInfo ({ commit }, user) {
      commit(SET_LOGIN_USER_INFO, user)
    },
    setInviteCode ({ commit }, data = {}) {
      commit(SET_INVITE_CODE, data)
    },
    jumpToSite ({ commit }, url = '') {
      commit(JUMP_TO_SITE, url)
    },
    setLocalInfo ({ commit }, value) {
      commit(SET_LOCAL_INFO, value)
    }
  }
  const mutations = {
    [SET_TOKENS] (state, value) {
      state.tokens = value
      SessionStorage.set(TOKENS, value)
    },
    [DEL_TOKENS] (state, value) {
      state.tokens = {}
      state.loginUserInfo = {}
      SessionStorage.remove(TOKENS)
      SessionStorage.remove(LOGIN_USER_INFO_KEY)
      SessionStorage.remove(LOGIN_USER_INVITE_CODE_KEY)
    },
    [SET_LOGIN_USER_INFO] (state, user) {
      state.loginUserInfo = user
      state.loginUserInfo.user_name = (user.org_exinfo && user.org_exinfo.real_name) || user.nick_name || user.user_name
      SessionStorage.set(LOGIN_USER_INFO_KEY, state.loginUserInfo)
    },
    [SET_INVITE_CODE] (state, data) {
      state.inviteCode = data
      SessionStorage.set(LOGIN_USER_INVITE_CODE_KEY, state.inviteCode)
    },
    [JUMP_TO_SITE] (state, value) {
      let url = `${LOTTERY_WEB_SITE.protocol}${LOTTERY_WEB_SITE.host}/#/${value}`
      if (state.tokens.access_token && auth.hasAuthorization(state.tokens)) {
        url = `${url}?auth=${encodeURIComponent(auth.getAuthorization('GET', '/', LOTTERY_WEB_SITE.host))}`
      }
      window.open(url)
    },
    [SET_LOCAL_INFO] (state, value) {
      state.localInfo = value
      SessionStorage.set(LOCAL_INFO, value)
    }
  }
  return {
    state,
    getters,
    actions,
    mutations
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/create-store.js